import React from "react";

const shapes = {
  rect: "var(--radius-none)",
  soft: "var(--radius-md)",
  arch: "var(--radius-arch)",
  circle: "50%",
};

/** Photography slot. Renders the image when `src` is set, otherwise a branded placeholder naming what belongs there. */
export function Photo({ src, alt = "", shape = "rect", ratio = "3 / 4", label = "Fotografía", fit = "cover", fill = false, style }) {
  const frame = {
    position: fill ? "absolute" : "relative",
    ...(fill ? { inset: 0, height: "100%" } : { aspectRatio: ratio }),
    width: "100%",
    borderRadius: shapes[shape],
    overflow: "hidden",
    background: "var(--accent-soft)",
    ...style,
  };
  if (src) {
    return (
      <div style={frame}>
        <img src={src} alt={alt} style={{ width: "100%", height: "100%", objectFit: fit }} />
      </div>
    );
  }
  return (
    <div style={{ ...frame, display: "grid", placeItems: "center", border: "var(--border-hair) solid var(--rule)" }}>
      <span style={{ fontFamily: "var(--font-caps)", fontSize: "var(--fs-micro)", letterSpacing: "var(--ls-wider)", textTransform: "uppercase", color: "var(--fg-muted)", textAlign: "center", padding: "0 12px" }}>
        {label}
      </span>
    </div>
  );
}
